import { Typography } from '@mui/material';
import { Call } from '../../model/calls/types';
import * as Styled from './styled';

export const CallData = ({ call, resident }: Call) => {
  const phone = call.phone.replace(
    /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
    '+$1 ($2) $3-$4-$5'
  );
  const name = resident ? resident.fullname : 'Неизвестный номер';

  return (
    <Styled.CallData>
      <Typography variant="body1">{phone}</Typography>

      <Styled.TypographyEllipsis variant="body2" color="textSecondary" title={name}>
        {name}
      </Styled.TypographyEllipsis>
    </Styled.CallData>
  );
};
